import {Component, EventEmitter, ViewEncapsulation} from '@angular/core';
import {Router} from "@angular/router";
import {LanguageChangeService} from '../../../services/language-change.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {DateTimeAdapter} from '@danielmoncada/angular-datetime-picker';
import {Config} from 'src/app/services/utils/Config';
import {document} from "ngx-bootstrap/utils";

export interface GdoHistoryOptionsModal {
  id: string
  activities: Object
  sources: Object,
  filters: Object
}
@Component({
  selector: 'app-gdo-history-filter-modal',
  templateUrl: './gdo-history-filter-modal.component.html',
  styleUrls: ['./gdo-history-filter-modal.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class GdoHistoryFilterModalComponent implements GdoHistoryOptionsModal {
  currentTab = 0;
  selectedActivities = [];
  filters;
  activities = [];
  sources = [];
  selectedSources = [];
  id: string;
  modalCss = 'modal-view';
  selectedMoments = [];
  fromDate;
  toDate;
  minDate;
  maxDate;
  errorDisplay = "";
  result: {};
  lastTab: number;
  tabs = {
    RANGE_PICKER: 2,
    USER_TYPE: 3,
    ACTIVITIES: 4
  }

  //Selected Language
  event: EventEmitter<any> = new EventEmitter();
  eventClose: EventEmitter<any> = new EventEmitter();

  langCode: string;
  defaultLangCode: string;
  holdLastActivity = [];
  holdSelectedMoments = [];
  holdSelectedSources = [];


  constructor(public router: Router,
              public bsModalRef: BsModalRef,
              private dateAdapter: DateTimeAdapter<any>,
              private langService: LanguageChangeService) {
    let date = new Date();
    this.toDate = date;
    date = new Date(Date.now() - (2 * 30 * 24 * 60 * 60 * 1000));
    this.fromDate = date;
    this.minDate = this.fromDate;
    this.maxDate = this.toDate + (12 * 60 * 60 * 1000); // add 12 hours
  }

  ngOnInit() {
    const currentLang = this.langService.getCurrentLanguage();
    this.dateAdapter.setLocale(currentLang === Config.LANGUAGES.FRENCH ? Config.LANGUAGES.FRENCH : Config.LANGUAGES.ENGLISH);
    this.langCode = currentLang;
    this.defaultLangCode = this.langService.getDefaultLanguage();

    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    this.selectedSources = this.filters.selectedSource || [];
    this.selectedActivities = this.filters.selectedActivities || [];
    this.selectedMoments = [this.filters.fromDate, this.filters.toDate];
  }

  private preSelectedValue(isBackButton: boolean, activeTabId: number) {
    const dataMap = {
      2: { current: this.selectedMoments, hold: this.holdSelectedMoments },
      3: { current: this.selectedSources, hold: this.holdSelectedSources },
      4: { current: this.selectedActivities, hold: this.holdLastActivity }
    };
    if (dataMap[activeTabId]) {
      if (isBackButton) {
        dataMap[activeTabId].current = [...dataMap[activeTabId].hold];
      } else {
        dataMap[activeTabId].hold = [...dataMap[activeTabId].current];
      }
    }
  }

  changeTab(tabId, filterApplied, IsBackButton = false, activeTabId = 1) {
    this.errorDisplay = "";
    this.preSelectedValue(IsBackButton, tabId);

    switch (tabId) {
      case this.tabs.RANGE_PICKER:
        this.lastTab = this.tabs.RANGE_PICKER;
        this.modalCss = 'modal-view-date-picker';
        break;
      case this.tabs.USER_TYPE:
        this.lastTab = this.tabs.USER_TYPE;
        this.modalCss = 'modal-view-input';
        break;
      case this.tabs.ACTIVITIES:
        this.lastTab = this.tabs.ACTIVITIES;
        this.modalCss = 'modal-view-list';
        break;
      default:
        if (!filterApplied) {
          this.emptyFilters();
        }
        this.modalCss = 'modal-view';
        this.preSelectedValue(IsBackButton, activeTabId);
    }
    this.currentTab = tabId;
  }

  emptyFilters() {
    switch (this.lastTab) {
      case this.tabs.RANGE_PICKER:
        this.selectedMoments = [];
        break;
      case this.tabs.USER_TYPE:
        this.selectedSources = [];
        break;
      case this.tabs.ACTIVITIES:
        this.selectedActivities = [];
        break;
    }
  }

  addActivityFilter(activity) {
    this.errorDisplay = "";
    const index = this.selectedActivities.findIndex(name => activity[this.defaultLangCode] === name[this.defaultLangCode]);
    index > -1 ? this.selectedActivities.splice(index, 1) : this.selectedActivities.push(activity);
  }

  addSourceFilter(event) {
    this.errorDisplay = "";
    if (event.target.value) {
      this.selectedSources = [event.target.value];
    } else {
      this.selectedSources = [];
    }
  }

  closeDialogue(selecteTab) {

    if (selecteTab === this.tabs.ACTIVITIES || selecteTab === this.tabs.USER_TYPE || selecteTab === this.tabs.RANGE_PICKER) {
      this.preSelectedValue(true, selecteTab);
    }
    let setFilter = false;
    if (this.selectedSources.length || this.selectedActivities.length || (this.selectedMoments[0] && this.selectedMoments[1])) {
      setFilter = true;
    }
    const [fromDate, toDate] = this.selectedMoments;
    this.result = { setFilter, selectedSource: this.selectedSources, selectedActivities: this.selectedActivities, fromDate, toDate }
    this.eventClose.emit(this.result);
    this.bsModalRef.hide();
    document.getElementsByTagName('body')[0].style.overflowY = 'scroll'
  }


  closeDialog() {
    const setFilter = this.selectedSources.length || this.selectedActivities.length || (this.selectedMoments[0] && this.selectedMoments[1]);
    const [fromDate, toDate] = this.selectedMoments;
    this.result = { setFilter, selectedSource: this.selectedSources, selectedActivities: this.selectedActivities, fromDate, toDate };
    this.event.emit(this.result);
    this.bsModalRef.hide();
    document.getElementsByTagName('body')[0].style.overflowY = 'scroll';
  }

  resetFilterAndCloseDialog() {
    this.result = { setFilter: false };
    this.event.emit(this.result);
    this.bsModalRef.hide();
    document.getElementsByTagName('body')[0].style.overflowY = 'scroll'
  }

  isActivityChecked(activity) {
    return this.selectedActivities.find(ele => ele[this.defaultLangCode] === activity[this.defaultLangCode]);
  }

}
